export const addAffiliateAccount = async (fields) => {
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/affiliate/addnewaccount",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(fields),
      }
    );
    const result = await response.json();
    localStorage.setItem("affiliate", result["tokenValue"]);
    localStorage.setItem("hotelID", result["hotelID"]);
    localStorage.setItem("affiliateType", result["accountType"]);
    window.location.reload();
  } catch (error) {
    alert(error.message);
  }
};
